import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const cleanParams = (params = {}) => Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
);

/**
 * Server-authorized Event Outreach reads (#887, #888, #898, #899).
 *
 * Every number on the Events list, the Event Overview and My Outreach comes
 * from these projections. The browser never recounts, narrows, or widens
 * them: `scope` / `owner_id` are requests the server may clamp.
 */
export function createEventOutreachApi(getAuthHeader) {
    const config = (params) => ({ headers: getAuthHeader ? getAuthHeader() : {}, params: cleanParams(params) });
    const get = (path, params) => axios.get(`${API}${path}`, config(params)).then((response) => response.data);
    const eventPath = (eventId) => `/events/${encodeURIComponent(eventId)}`;

    return {
        getBoard: (eventId, params = {}) => get(`${eventPath(eventId)}/outreach/board`, params),
        getWorkspace: (params) => get('/events/workspace', params),
        getOverview: (eventId, params) => get(`${eventPath(eventId)}/overview`, params),
        getSummary: (params) => get('/reports/outreach/summary', params),
        getByEvent: (params) => get('/reports/outreach/by-event', params),
        getByOwner: (params) => get('/reports/outreach/by-owner', params),
    };
}

export default createEventOutreachApi;
